import styled from '@emotion/styled'
import { breakpoint, calcRem } from '../../__styling'

export interface StyledRadioProps {
    size: number
    checked: boolean
}

export const StyledRadioDot = styled('span')<StyledRadioProps>(
    ({ size, checked, theme }) => [
        {
            width: calcRem(size),
            height: calcRem(size),
            borderRadius: '50%',
            border: `${calcRem(1)} solid #E5E5E5`,
            display: 'flex',
            alignContent: 'center',
            justifyContent: 'center',
        },
        checked && {
            border: `${calcRem(1)} solid ${theme.colors.brand}`,
        },
    ],
)

export const StyledRadioDotInner = styled('span')<StyledRadioProps>(
    ({ size, checked, theme }) => [
        {
            display: 'flex',
            width: calcRem((size / 3) * 2),
            height: calcRem((size / 3) * 2),
            borderRadius: '50%',
            margin: 'auto',
            backgroundColor: 'transparent',
        },
        checked && {
            backgroundColor: theme.colors.brand,
            [breakpoint('xs')]: {
                backgroundColor: theme.colors.brand,
            },
        },
    ],
)
